import trainerSessionsService from "@/modules/cardioguard-trainer/services/trainerSessionsService";
import trainerSessionSignatures from "@/modules/cardioguard-trainer/services/trainerSessionsSignaturesService";
import trainerFinishedCourseInscriptions from "@/modules/cardioguard-trainer/services/trainerFinishedCourseInscriptionsService";

export default [
  trainerSessionsService,
  trainerSessionSignatures,
  trainerFinishedCourseInscriptions,
];
